<template>
  <div class="timeline-box">
    <div class="timeline-box-title">项目进度</div>
    <div class="timeline" v-ps>
      <div
        class="timeline-item-empty"
        v-if="milestoneList == undefined || milestoneList.length == 0"
      >
        暂无里程碑
      </div>
      <template v-else>
        <div class="timeline-item" v-for="(milestone, index) in milestoneList" :key="index">
          <div
            class="item-main"
            :class="
              index !== milestoneList.length - 1 &&
              showToday(milestoneList[index].dueDate, milestoneList[index + 1].dueDate)
                ? 'item-main-today'
                : ''
            "
          >
            <div class="item-time-label" v-if="index !== milestoneList.length - 1">
              <div class="time-program">
                {{
                  milestoneList[index + 1].dueDateStr === ""
                    ? "暂无排期"
                    : "计划：" + milestoneList[index + 1].dueDateStr + "天"
                }}
              </div>
              <div class="time-real" v-if="milestoneList[index + 1].completeAtStr !== ''">
                实际：{{ milestoneList[index + 1].completeAtStr }}天
              </div>
              <div
                v-if="showToday(milestoneList[index].dueDate, milestoneList[index + 1].dueDate)"
                class="today-label"
              >
                <svg-icon icon-class="project_today" class="today-label-icon" />
              </div>
            </div>
            <div style="height: 20px " v-else></div>
            <div class="item-status">
              <div class="item-tag">
                <svg-icon
                  v-if="milestone.status === '已完成'"
                  class="tag-icon"
                  icon-class="project_milestone-completed"
                />
                <svg-icon v-else class="tag-icon" icon-class="project_milestone-unfinished" />
              </div>
              <div
                v-if="index !== milestoneList.length - 1"
                class="item-line"
                :class="milestone.status === '已完成' ? 'item-line-yes' : 'item-line-not'"
              ></div>
            </div>
            <div class="item-tamp" v-tip>{{ milestone.name }}</div>
            <div class="item-time">
              <div class="time-program">
                {{
                  milestone.dueDate === undefined
                    ? "暂无排期"
                    : "计划：" + milestone.dueDate.substring(0, 10)
                }}
              </div>
              <div
                class="time-real"
                :style="milestone.completeAt === undefined ? 'color: #fff' : 'color: #1989FA'"
              >
                {{
                  milestone.completeAt === undefined
                    ? "无"
                    : "实际：" + milestone.completeAt.substring(0, 10)
                }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeLine",
  props: {
    milestoneList: Array,
    from: String
  },
  data() {
    return {
      nowTime: Date
    }
  },
  created() {
    this.nowTime = new Date().getTime()
  },
  methods: {
    showToday(startTime, endTime) {
      let hasToday = Boolean(
        this.nowTime >= Date.parse(startTime) && this.nowTime <= Date.parse(endTime)
      )
      if (hasToday) this.$emit("hasToday")
      return hasToday
    }
  }
}
</script>

<style scoped lang="scss">
.timeline-box {
  width: calc(100% - 64px);
  background: #ffffff;
  border-radius: 6px;
  padding: 14px 16px 0 16px;
  .timeline-box-title {
    font-size: 16px;
    font-weight: 500;
    color: #313132;
    line-height: 22px;
  }
  .timeline {
    display: flex;
    flex-direction: row;
    padding: 12px 24px;

    .timeline-item {
      display: flex;
      flex-direction: row;
      align-items: center;

      .item-main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .item-time-label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 180px;
          margin-left: 32px;

          div {
            font-size: 12px;
            font-weight: 500;
            padding: 1px 5px;
            line-height: 17px;
            border-right: 2px;
          }

          .time-program {
            color: #8f9193;
            background-color: #f4f5f7;
          }

          .time-real {
            margin-left: 4px;
            color: #1989fa;
            background: rgba(25, 137, 250, 0.1);
          }
          .today-label {
            width: 35px;
            height: 50px;
            border-left: 2px solid #fd6565;
            position: relative;
            bottom: -15px;
            margin-left: 13px;
            .today-label-icon {
              font-size: 35px;
              position: relative;
              left: -7px;
              top: -9px;
            }
          }
        }

        .item-status {
          display: flex;
          align-items: center;
          justify-content: center;

          .item-tag {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            box-shadow: 0 1px 6px 0 rgba(192, 196, 204, 0.4);
            border: 2px solid #ffffff;

            .tag-icon {
              font-size: 46px;
              position: relative;
              left: -7px;
              top: -7px;
            }
          }

          .item-line {
            width: 180px;
            height: 6px;
            background: #1989fa;
          }
          .item-line-not {
            background: rgba(220, 223, 230, 0.5);
          }
        }

        .item-tamp {
          max-width: 180px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          font-weight: 500;
          color: #313132;
          line-height: 20px;
        }

        .item-time {
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          min-width: 150px;

          .time-program {
            color: #8f9193;
          }
        }
      }
      .item-main-today {
        position: relative;
        top: -16px;
        z-index: 100 !important;
        .item-time-label,
        .item-line {
          width: 215px !important;
        }
        .time-program,
        .time-real {
          position: relative;
          top: 16px;
        }
        .item-time {
          position: relative;
          top: -16px;
        }
      }
    }
    .timeline-item-empty {
      height: 110px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 60px;
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
